
const screeningVariable = {
    positionTypeList: [
        { name: '其他', value: '0' },
        { name: '全职', value: '1' },
        { name: '兼职', value: '2' },
        { name: '零工', value: '3' },
        { name: '实习', value: '4' },
    ],

    // 零工之家
    sidelineList: [
        { name: '兼职', value: '2' },
        { name: '零工', value: '3' },
    ],

    workliftList: [
        { name: '不限', value: '0' },
        { name: '1年以下', value: '1' },
        { name: '1-3年', value: '2' },
        { name: '3-5年', value: '3' },
        { name: '5-10年', value: '4' },
        { name: '10年以上', value: '5' },
    ],

    eduList: [
        { name: '不限', value: 'bx' },
        { name: '小学', value: '81' },
        { name: '初中', value: '71' },
        { name: '中专', value: '41' },
        { name: '高中', value: '61' },
        { name: '技校', value: '47' },
        { name: '职高', value: '44' },
        { name: '大专', value: '31' },
        { name: '本科', value: '21' },
        { name: '硕士研究生', value: '14' },
        { name: '博士研究生', value: '11' },
    ],

    salaryList: [
        { name: '不限', value: '0' },
        { name: '1千以下', value: '1' },
        { name: '1千-2千', value: '2' },
        { name: '2千-3千', value: '3' },
        { name: '3千-5千', value: '4' },
        { name: '5千-8千', value: '5' },
        { name: '8千-1.5万', value: '6' },
        { name: '1.5万-2万', value: '7' },
        { name: '2万以上', value: '8' },
    ]
}

export default screeningVariable;